import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { Subject, takeUntil } from 'rxjs';
import { ReferentialsNaturesService } from '../referentials-natures.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GenericErrorResponse } from '../../../../../core/models/generic-response.model';
import { MessageService } from 'primeng/api';
import { InlineResponse } from '../../../../../core/models/inline-response.model';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { provideTranslocoScope, TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-add-nature',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, DynamicDialogModule, InputTextModule, InputGroupModule, InputGroupAddonModule, ConfirmDialogModule, ReactiveFormsModule, ToastModule, MessagesModule, MessageModule, ProgressSpinnerModule, TranslocoModule],
  providers: [DialogService, MessageService, provideTranslocoScope({ scope: 'referentiels' })],
  templateUrl: './add-nature.component.html',
  styleUrl: './add-nature.component.css',
})
export class AddNatureComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  disableSubmit = false;
  errors: GenericErrorResponse[] = [];
  submitting: boolean = false;

  natureForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private natureService: ReferentialsNaturesService,
    private messageService: MessageService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.natureForm = this.formBuilder.group({
      codeHecate: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      designation: ['', [Validators.required]],
    });
  }

  addNature() {
    this.submitting = true;
    const codeHecate = this.natureForm.controls.codeHecate.value;
    const designation = this.natureForm.controls.designation.value;

    this.natureService.addNatureData(codeHecate, designation).subscribe({
      next: (response) => {
        this.handleInlineResponse(response);
        this.submitting = false;
      },
      error: (error) => {
        this.handleHttpErrorResponse(error);
      },
    });
  }

  private handleInlineResponse(response: InlineResponse): void {
    this.disableSubmit = false;
    if (response.success) {
      this.close(true);
    } else {
      this.errors = response.errors;
      this.messageService.add({
        severity: 'error',
        summary: this.translocoService.translate('error.popup.titre.defaut'),
        detail: 'Une erreur est survenue : ' + this.errors.map((e) => e.errorMsg).join(', '),
        life: 3000,
      });
    }
  }

  private handleHttpErrorResponse(error: HttpErrorResponse) {
    this.disableSubmit = false;
    this.errors = [];
    this.errors.push({
      errorInputId: error.status.toString(),
      errorCode: error.status.toString(),
      errorMsg: error.statusText,
    } as GenericErrorResponse);
    this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue : ' + error.statusText, life: 3000 });
  }

  close(result: boolean): void {
    this.ref.close(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
